import onDomReady from '../../utils/dom/onDomReady';
import { HeaderSearchAutocomplete } from '../../features/ui/HeaderSearchAutocomplete';

onDomReady(() => {
  const form = document.querySelector<HTMLFormElement>('.js-cms-header-search-form');

  if (!form) {
    return;
  }

  try {
    new HeaderSearchAutocomplete(form);
  } catch {
    // Keep default form behavior when search config is unavailable.
    return;
  }
});
